import { IntlShape } from 'localization';
import * as yup from 'yup';

const paymentValidationSchema = (t: IntlShape) => {
  const requiredMessage = t.formatMessage({ id: '3PL.error.required-message' });
  const invalidCardNumber = t.formatMessage({ id: 'settings.payment.invalid-card-number' });

  const trimAndRemoveSpaces = (value: string) =>
    (value ? value.trim().replace(/\s/g, '') : '').replace(/[^0-9]/g, '');

  return yup.object().shape({
    plan: yup.string().required(requiredMessage),
    paymentMethods: yup.array(),
    holderName: yup.string().required(requiredMessage),
    number: yup.string().when('paymentMethod', {
      is: (value: string) => value === 'new',
      then: (schema) =>
        schema.transform(trimAndRemoveSpaces).min(16, invalidCardNumber).required(requiredMessage),
      otherwise: (schema) => schema.required(requiredMessage),
    }),
    expiry: yup
      .string()
      .transform((value) => value?.replace(/[^0-9]/g, ''))
      .min(4)
      .required(requiredMessage)
      .test('valid-expiry', '', function (value) {
        if (!value || value.length !== 4) return false;

        const month = parseInt(value.substring(0, 2), 10);
        const year = parseInt(value.substring(2, 4), 10) + 2000;
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1;

        // Check valid month (1-12)
        if (month < 1 || month > 12) return false;

        // Check year range (current year to current year + 10)
        if (year < currentYear || year > currentYear + 10) return false;

        // Check if expiry date is not in the past
        if (year === currentYear && month < currentMonth) return false;

        return true;
      }),
    cvc: yup.string().min(3).max(4).required(requiredMessage),
    acceptedTerms: yup.boolean().oneOf([true], requiredMessage),
  });
};

const shopifyPaymentValidationSchema = (t: IntlShape) => {
  const requiredMessage = t.formatMessage({ id: '3PL.error.required-message' });

  return yup.object().shape({
    plan: yup.string().required(requiredMessage),
    acceptedTerms: yup.boolean().oneOf([true], requiredMessage),
  });
};

export { paymentValidationSchema, shopifyPaymentValidationSchema };
